import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodSampleAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-blood-sample-slot',
    templateUrl: './blood-sample-slot.component.html',
    styleUrl: './blood-sample-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodSampleSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BloodSampleAction;
	value = null;

	constructor() {
	}
}